import { render } from "./개인정보처리방침.vue?vue&type=template&id=018ef3b9"
import script from "./개인정보처리방침.vue?vue&type=script&lang=js"
export * from "./개인정보처리방침.vue?vue&type=script&lang=js"

import "./개인정보처리방침.vue?vue&type=style&index=0&id=018ef3b9&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__